import { call, put, takeLatest } from "redux-saga/effects";
import request from "../../api/request";

function* getOrderTypes() {
    try {
        yield put({
            type: "FETCH_ORDER_TYPES_REQUESTING",
        });

        yield put({
            type: "SHOW_LOADING",
        });

        const requestURL = `${process.env.REACT_APP_API_URL}/api/v1/order-types`;

        const headers = {
            method: "GET",
            headers: {
                Authorization: `Bearer ${window.localStorage.getItem("token")}`,
                "Content-Type": "application/json",
            },
        };

        const response = yield call(request, requestURL, headers);

        yield put({
            type: "FETCH_ORDER_TYPES_SUCCESS",
            value: response,
        });
    } catch (error) {
        yield put({
            type: "SHOW_ALERT",
            value: {
                type: "danger",
                title: "Failed to load",
                message: "Failed to load order types",
            },
        });
        yield put({
            type: "FETCH_ORDER_TYPES_ERROR",
        });
    } finally {
        yield put({
            type: "HIDE_LOADING",
        });
    }
}

export function* watchOrderTypes() {
  yield takeLatest("FETCH_ORDER_TYPES_REQUEST", getOrderTypes);
}